import { render, staticRenderFns } from "./InfoText.vue?vue&type=template&id=950baa54&scoped=true"
import script from "./InfoText.vue?vue&type=script&lang=js"
export * from "./InfoText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950baa54",
  null
  
)

export default component.exports